import { apiGeneral } from './_General';

export const apiWebPage = {
  getPageData(path, cb, eCb) {
    apiGeneral.apiFetch('public/pages', {
      path
    }, null, cb, eCb);
  }
};
